import { FC } from 'react';
import SliderInput, {
  SliderInputProps,
} from 'presentation/components/shared/fields/SliderInput';
import AppFormControl from './AppFormControl';

interface Props extends SliderInputProps, FormFieldProps {}

const FormSliderInput: FC<Props> = ({
  label,
  helperText,
  subLabel,
  ...props
}) => {
  return (
    <AppFormControl
      name={props.name}
      label={label}
      helperText={helperText}
      subLabel={subLabel}
    >
      <SliderInput {...props} />
    </AppFormControl>
  );
};

export default FormSliderInput;
